import { createElement } from 'react';
import type { ComponentPropsWithoutRef, JSX, ReactElement } from 'react';
import { buildComponentMeta, useComponentMeta } from '../../ui';
import { operationsMeta } from './componentMeta';

export function OperationsElement<T extends keyof JSX.IntrinsicElements = 'div'>({ as, meta, instance, ...props }:
  { as?: T; meta: string; instance?: string } & ComponentPropsWithoutRef<T>): ReactElement {
  const declaration = operationsMeta(meta);
  const complete = buildComponentMeta({ ...declaration, id: `${declaration.id}${instance ? `.${instance}` : ''}` });
  const ref = useComponentMeta<HTMLElement>(complete);
  return createElement(as ?? 'div', { ...props, ref, 'data-ui-id': complete.id, 'data-ui-role': complete.role });
}
